import "core-js/modules/es6.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { useDeprecatedComponentWarning } from '@nerdwallet/deprecate';
import { useIconProps } from '../useIconProps';

var Help = function Help(props) {
  useDeprecatedComponentWarning({
    component: 'Help'
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 2048"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M1040 256q159 0 304 62t250.5 167.5T1762 736t62 304q0 157-59.5 300T1594 1594t-254 170.5-300 59.5q-159 0-304-62t-250.5-167.5T318 1344t-62-304q0-157 59.5-300T486 486t254-170.5 300-59.5zm446 1230q89-89 136.5-204.5T1670 1040q0-171-84.5-316T1356 494.5 1040 410q-126 0-241.5 47.5T594 594 457.5 798.5 410 1040q0 171 84.5 316T724 1585.5t316 84.5q127 0 242-47.5t204-136.5zm-526-46v-160h160v160H960zm96-832q110 0 183 64t73 160q0 46-20 85.5t-48 67-56 52.5-48 54.5-20 60.5v32H960v-52q0-47 18.5-85.5t45.5-64 54.5-47 48.5-46 24-50.5q5-47-21-75t-74-28q-45 0-70.5 38T960 864H800q0-117 72.5-186.5T1056 608z"
  }));
};

Help.displayName = 'Help';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Help.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default Help;